import React from 'react';
import { ChevronDown, ArrowUpDown } from 'lucide-react';

const SortControls = ({ 
  sortOption, 
  setSortOption, 
  sortOrder, 
  setSortOrder, 
  podcastTypes, 
  setPodcastTypes 
}) => {
  const sortOptions = [
    { value: 'date', label: 'Date' },
    { value: 'title', label: 'Titre' },
    { value: 'score', label: 'Score moyen' }
  ];

  const podcastTypeOptions = [
    { value: 'floodcast', label: 'Floodcast' },
    { value: 'podchiasse', label: 'Podchiasse' }
  ];

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  };

  const handlePodcastTypeChange = (type) => {
    if (podcastTypes.includes(type)) {
      setPodcastTypes(podcastTypes.filter(t => t !== type));
    } else {
      setPodcastTypes([...podcastTypes, type]);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-6 mb-6">
      {/* Section tri */}
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-text-secondary">Trier par :</span>
        
        <div className="relative">
          <select
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            className="appearance-none bg-background-input border border-border-color rounded-lg px-4 py-2 pr-8 text-sm text-text-primary focus:outline-none focus:ring-2 focus:ring-primary-color focus:border-primary-color"
          >
            {sortOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ChevronDown className="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-text-muted pointer-events-none" />
        </div>

        <button
          onClick={toggleSortOrder}
          className="btn btn-secondary flex items-center gap-2 px-3 py-2 text-sm"
        >
          <ArrowUpDown className="w-4 h-4" />
          <span>{sortOrder === 'asc' ? 'Croissant' : 'Décroissant'}</span>
        </button>
      </div>

      {/* Section podcasts */}
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-text-secondary">Podcasts :</span>
        <div className="flex items-center gap-4">
          {podcastTypeOptions.map(option => (
            <label key={option.value} className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={podcastTypes.includes(option.value)}
                onChange={() => handlePodcastTypeChange(option.value)}
                className="w-4 h-4 text-primary-color bg-background-input border-border-color rounded focus:ring-primary-color focus:ring-2"
              />
              <span className="text-sm text-text-primary">{option.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SortControls;